import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import TermsAgreementModal from "@/components/TermsAgreementModal";
import { useAppInitQuery, useAuthSelectProfileMutation, useLoginTermsLazyQuery, useModal } from "@/hooks";
import config from "@/lib/config";
import notAgreementTermsFilter from "@/lib/notAgreementTermsFilter";
import routes from "@/lib/routes";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";

// Appの初期化処理をする
import { jsx as _jsx } from "react/jsx-runtime";
export function useAppInit() {
  const router = useRouter();
  const {
    0: state,
    1: setState
  } = useState({
    selectedProfile: undefined
  });
  const {
    showModal
  } = useModal();
  const [selectedProfileMutation] = useAuthSelectProfileMutation();
  const [getLoginTerms, {
    data: termsData
  }] = useLoginTermsLazyQuery();
  const {
    loading: appLoading,
    data
  } = useAppInitQuery({
    fetchPolicy: "cache-first"
  });
  const user = data === null || data === void 0 ? void 0 : data.user;
  const deviceInfo = data === null || data === void 0 ? void 0 : data.deviceInfo;
  const loading = useMemo(() => {
    // ロード済みでユーザーがない（未ログイン）場合はプロフィールの選択状況は見ない
    if (!appLoading && !user) {
      return false;
    }
    return appLoading || typeof state.selectedProfile === "undefined";
  }, [state.selectedProfile, appLoading, user]);
  useEffect(() => {
    // アプリから参照されるページ、クローラーは海外判定しない
    if (deviceInfo && !(deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isBot) && !~router.asPath.indexOf("/app/static") && router.asPath !== routes.geoRestriction) {
      fetch(config.ipCheckURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      }).then(res => res.json()).then(res => {
        if (!res.accessibility) {
          window.location.href = routes.geoRestriction;
        }
      });
    }
  }, [deviceInfo]);
  useEffect(() => {
    if (user) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        PaidOTTmemberId: user.hashedUserId
      });
    }
  }, [user]);
  useEffect(() => {
    let getTermTimeoutId;
    if (!appLoading) {
      let disabled = false;
      let selected = true;
      if (user) {
        // プロフィールが1つしかなかったら自動で選択する
        if (!user.currentProfile && !disabled) {
          if (user.profiles.length == 1) {
            const profile = user.profiles[0];
            if (!profile.needPasscode) {
              selectedProfileMutation({
                variables: {
                  profileId: parseInt(profile.id, 10)
                }
              });
              selected = true;
            } else {
              selected = false;
            }
          } else {
            selected = false;
          }
        }
        // 規約の同意状況を取得
        if (user.currentProfile && !disabled) {
          getTermTimeoutId = setTimeout(() => {
            getLoginTerms({
              fetchPolicy: "network-only"
            });
          }, 100);
        }
      }
      setState({
        selectedProfile: selected
      });
    }
    return () => {
      clearTimeout(getTermTimeoutId);
    };
  }, [appLoading, user]);
  useEffect(() => {
    if (user && termsData && !~router.asPath.indexOf("/static/legal") && !router.asPath.includes("/signup") && !router.asPath.includes("/logout")) {
      // 規約の同意状況をチェックする
      fetch("/api/optional_terms").then(res => res.json()).then(_ref => {
        let {
          confirm
        } = _ref;
        const filterdTerms = notAgreementTermsFilter([...termsData.required, ...termsData.optional], !confirm).filter(filterdTerm => {
          const optOutConditionVod = filterdTerm.id_key === "spoox_mail" && user.receiveAdvertisingMailType === 2;
          return !optOutConditionVod;
        });
        if (filterdTerms.length > 0) {
          const required = filterdTerms.find(term => term.required);
          const optional = filterdTerms.find(term => !term.required);
          showModal( /*#__PURE__*/_jsx(TermsAgreementModal, {
            terms: filterdTerms
          }), {
            closeButton: !required,
            outerAreaClose: !required,
            style: "termsAgreementModal"
          });
          return {
            viewOptionalTerms: !!optional
          };
        } else {
          return {
            viewOptionalTerms: false
          };
        }
      }).then(_ref2 => {
        let {
          viewOptionalTerms
        } = _ref2;
        if (viewOptionalTerms) {
          fetch("/api/optional_terms", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              confirm: true
            })
          });
        }
      });
    }
  }, [user, termsData, router.asPath]);
  useEffect(() => {
    let authIntervalId;
    const authCheck = async () => {
      return await fetch(`/api/auth_check?ts=${+new Date()}`).then(res => res.json());
    };
    const startInterval = () => {
      // ページを放置したときにトークンのexpireが切れないように60分ごとにリクエストする
      clearInterval(authIntervalId);
      authIntervalId = setInterval(async () => await authCheck(), 60 * 60 * 1000);
    };
    const onBlur = () => {
      clearInterval(authIntervalId);
    };
    const onFocus = async () => {
      await authCheck();
      startInterval();
    };
    if (user) {
      window.addEventListener("blur", onBlur);
      window.addEventListener("focus", onFocus);
      startInterval();
    }
    return () => {
      clearInterval(authIntervalId);
      window.removeEventListener("blur", onBlur);
      window.removeEventListener("focus", onFocus);
    };
  }, [user]);
  return _objectSpread(_objectSpread({
    loading,
    user
  }, state), {}, {
    deviceInfo
  });
}